export default __webpack_public_path__ + "static/media/BIVIANA-RIVEIRO.64dcf4b1.jpg";